import { gql } from "apollo-boost";

export const CREATE_PROVIDER = gql`
  mutation CreateProvider($input: CreateProviderInput!) {
    createProvider(input: $input) {
      id
    }
  }
`;
